import QRCodeLib from 'qrcode';

/**
 * Ouvre une fenêtre d'impression avec une étiquette colis pleine page A4
 * (grand format lisible). Factorisé depuis les dashboards.
 */
export async function printPackageLabel(pkg, opts = {}) {
  if (!pkg) return;
  const { logoUrl = '', companyName = 'FretManager' } = opts;

  let qrDataUrl = '';
  try {
    qrDataUrl = await QRCodeLib.toDataURL(pkg.oce_code || '', {
      width: 400, margin: 1, errorCorrectionLevel: 'M',
    });
  } catch (_) { /* fallback: label without QR */ }

  const w = window.open('', '_blank', 'width=800,height=1000');
  if (!w) return;

  const fmtDate = (() => {
    try {
      return new Date(pkg.created_at).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
    } catch (_) { return ''; }
  })();

  const destCity = (pkg.destination_city || pkg.destination_country || '').toUpperCase();
  const destSuffix = pkg.destination_city && pkg.destination_country ? ' — ' + pkg.destination_country.toUpperCase() : '';

  w.document.write(`<!DOCTYPE html>
<html><head><meta charset="utf-8"/>
<title>Étiquette ${pkg.oce_code || ''}</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet">
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  @page { size: A4 portrait; margin: 12mm; }
  body { font-family: 'Inter', sans-serif; color: #1a1a2e; padding: 0; }
  .label { border: 4px solid #1a1a2e; border-radius: 4mm; overflow: hidden; width: 100%; }
  .header { background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%); color: #fff; padding: 10mm 8mm; }
  .header-row { display: flex; align-items: center; justify-content: center; gap: 10mm; }
  .oce { font-size: 42pt; font-weight: 800; letter-spacing: 2px; }
  .brand { font-size: 12pt; text-transform: uppercase; letter-spacing: 5px; opacity: 0.7; margin-top: 3mm; }
  .qr img { width: 48mm; height: 48mm; border-radius: 2mm; background: #fff; padding: 1.5mm; }
  .logo img { max-height: 40mm; max-width: 55mm; object-fit: contain; background: #fff; border-radius: 2mm; padding: 1.5mm; }
  .oce-block { text-align: center; margin-top: 6mm; }
  .dest-box { background: #0f3460; color: #fff; text-align: center; padding: 8mm; font-size: 26pt; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; }
  .route { text-align: center; font-size: 22pt; font-weight: 700; padding: 6mm 0; background: #f0f4ff; color: #0f3460; }
  .route .arrow { font-size: 26pt; color: #e94560; margin: 0 4mm; }
  .body { padding: 8mm; }
  .section { margin-bottom: 6mm; padding-bottom: 6mm; border-bottom: 1.5px solid #e0e4ef; }
  .section:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
  .title { font-size: 11pt; text-transform: uppercase; color: #0f3460; font-weight: 700; letter-spacing: 1px; margin-bottom: 1.5mm; }
  .value { font-size: 18pt; font-weight: 600; color: #1a1a2e; }
  .small { font-size: 14pt; color: #555; font-weight: 400; }
  .grid { display: flex; justify-content: space-between; gap: 6mm; }
  .grid > div { width: 48%; }
  .footer { text-align: center; background: #f8f9fc; padding: 6mm; border-top: 1.5px solid #e0e4ef; }
  .footer .title { margin-bottom: 1mm; }
  @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
</style>
</head><body>
<div class="label">
  <div class="header">
    <div class="header-row">
      ${logoUrl ? `<div class="logo"><img src="${logoUrl}" alt="logo"/></div>` : ''}
      ${qrDataUrl ? `<div class="qr"><img src="${qrDataUrl}" alt="QR"/></div>` : ''}
    </div>
    <div class="oce-block">
      <div class="oce">${pkg.oce_code || ''}</div>
      <div class="brand">${companyName}</div>
    </div>
  </div>

  <div class="dest-box">${destCity}${destSuffix}</div>

  <div class="route">
    ${pkg.origin_country || ''} <span class="arrow">&#10132;</span> ${pkg.destination_country || ''}
  </div>

  <div class="body">
    <div class="section">
      <div class="grid">
        <div>
          <div class="title">Expéditeur</div>
          <div class="value">${pkg.sender_name || ''}</div>
          <div class="small">${pkg.sender_phone || ''}</div>
        </div>
        <div>
          <div class="title">Destinataire</div>
          <div class="value">${pkg.recipient_name || ''}</div>
          <div class="small">${pkg.recipient_phone || ''}</div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="grid">
        <div>
          <div class="title">Poids</div>
          <div class="value">${pkg.weight || 0} kg</div>
        </div>
        <div>
          <div class="title">Description</div>
          <div class="small">${pkg.description || '-'}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div class="title">Date d'enregistrement</div>
    <div class="small">${fmtDate}</div>
  </div>
</div>
<script>window.onload=function(){window.print();}<\/script>
</body></html>`);
  w.document.close();
}
